export const ASPHALT_TON_CONVERSION_FACTOR = {
  "0.5": 0.0035,
  "0.75": 0.0046,
  "1": 0.007,
  "1.25": 0.0085,
  "1.5": 0.01,
  "1.75": 0.0115,
  "2": 0.013,
  "2.25": 0.0145,
  "2.5": 0.016,
  "2.75": 0.0175,
  "3": 0.019,
  "3.25": 0.0205,
  "3.5": 0.022,
  "3.75": 0.0235,
  "4": 0.025,
  "4.5": 0.028,
  "5": 0.031,
  "5.5": 0.0335,
  "6": 0.036,
  "6.5": 0.0395,
  "7": 0.043,
  "7.5": 0.046,
  "8": 0.049,
  "9": 0.055,
  "10": 0.061,
  "11": 0.068,
  "12": 0.074,
  "13": 0.084,
  "14": 0.09,
  "15": 0.096,
  "17": 0.102,
  "18": 0.108,
  "19": 0.114,
  "20": 0.12,
  "21": 0.126,
  "22": 0.132,
  "23": 0.138,
  "24": 0.144,
};
